import { render, staticRenderFns } from "./customValidateInput.vue?vue&type=template&id=97244a9a&scoped=true"
import script from "./customValidateInput.vue?vue&type=script&lang=js"
export * from "./customValidateInput.vue?vue&type=script&lang=js"
import style0 from "./customValidateInput.vue?vue&type=style&index=0&id=97244a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97244a9a",
  null
  
)

export default component.exports